import React from "react";
import FormSelect from "Common/Custom/FormSelect";
import FormSubmitButton from "Common/Custom/FormSubmitButton";

const EditAssignedEmployeeForm = ({
    formFields,
    values,
    errors,
    handleChange,
    setValues,
    rosterOptions,
    employeeOptions,
    isRosterSelected,
    loadingSubmit
}) => {
    return (
        <>
            {formFields.map((field) => {
                // 🔹 Roster Select Field
                if (field.type === "select" && field.name === "roster_id") {
                    return (
                        <FormSelect
                            key={field.name}
                            field={{ ...field, disabled: true, label: "Select Roster to Edit" }}
                            value={values[field.name]}
                            handleChange={handleChange}
                            options={rosterOptions}
                            error={errors[field.name]}
                            disabled={true}
                        />
                    );
                }

                // 🔹 Employees Selection Grid (Only if roster is selected)
                if (field.name === "employee_ids" && isRosterSelected) {
                    return (
                        <div className="col-12 mt-4 animate-fade-in" key={field.name}>
                            <div className="d-flex align-items-center justify-content-between mb-3 px-1">
                                <h6 className="fw-bold mb-0">{field.label}</h6>
                                <span className="badge bg-soft-info text-info border-0 px-2">
                                    {values.employee_ids.length} Selected
                                </span>
                            </div>

                            <div className="employee-grid-container row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xxl-4 g-3" style={{ maxHeight: '600px', overflowY: 'auto', overflowX: 'hidden' }}>
                                {employeeOptions.length > 0 ? (
                                    employeeOptions.map((emp, index) => {
                                        const isAssignedElsewhere = emp.assigned_roster_id && parseInt(emp.assigned_roster_id) !== parseInt(values.roster_id);
                                        const isSelected = values.employee_ids.includes(emp.value);

                                        const getInitials = (name) => {
                                            if (!name) return "??";
                                            return name.split(" ").map((n) => n[0]).join("").substring(0, 2).toUpperCase();
                                        };

                                        const varIndex = (index % 6) + 1;

                                        return (
                                            <div key={emp.value} className="col">
                                                <div
                                                    className={`employee-selection-card variant-${varIndex} ${isAssignedElsewhere ? 'is-assigned' : isSelected ? 'is-selected' : ''}`}
                                                    onClick={() => {
                                                        if (isAssignedElsewhere) return;
                                                        const id = emp.value;
                                                        const newIds = isSelected
                                                            ? values.employee_ids.filter(i => i !== id)
                                                            : [...values.employee_ids, id];
                                                        setValues(prev => ({ ...prev, [field.name]: newIds }));
                                                    }}
                                                >
                                                    <div className="card-body">
                                                        <div className="d-flex align-items-center mb-0">
                                                            <div className="avatar-box">
                                                                {getInitials(emp.name)}
                                                            </div>
                                                            <div className="emp-info">
                                                                <h6 className="emp-name" title={emp.name}>{emp.name}</h6>
                                                                <span className="emp-pos">{emp.position}</span>
                                                            </div>
                                                            {isAssignedElsewhere && (
                                                                <span className="status-badge">
                                                                    <i className="fa fa-lock"></i>
                                                                </span>
                                                            )}
                                                            {!isAssignedElsewhere && (
                                                                <div className="selection-indicator">
                                                                    <div className="form-check p-0 m-0">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            checked={isSelected}
                                                                            readOnly
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="col-12 w-100">
                                        <div className="alert border-0 shadow-sm text-center py-5 rounded-4">
                                            <i className="fa fa-users-slash d-block mb-3 fs-1 opacity-50"></i>
                                            <h5 className="mb-0">No employees found</h5>
                                        </div>
                                    </div>
                                )}
                            </div>
                            {errors[field.name] && <div className="text-danger small mt-2 ms-1"><i className="fa fa-exclamation-triangle me-1"></i>{errors[field.name]}</div>}
                        </div>
                    );
                }

                return null;
            })}

            {isRosterSelected && (
                <div className="col-12 text-end mt-4">
                    <FormSubmitButton
                        type="submit"
                        loading={loadingSubmit}
                        className="btn btn-primary px-4"
                    >
                        Update Assignments
                    </FormSubmitButton>
                </div>
            )}
        </>
    );
};

export default EditAssignedEmployeeForm;
